"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBioProperty = exports.bioPropertyDefinition = void 0;
exports.bioPropertyDefinition = {
    view: { label: 'Bio' },
    constraints: [],
    type: 'rich-text',
    multiple: true,
    name: 'bio',
};
const isBioProperty = (prop) => {
    return prop.name === exports.bioPropertyDefinition.name;
};
exports.isBioProperty = isBioProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmlvLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYmlvLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUJBQXFCLEdBQUc7SUFDbkMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRTtJQUN0QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLEtBQUs7Q0FDb0IsQ0FBQTtBQUkxQixNQUFNLGFBQWEsR0FBRyxDQUFDLElBQWtCLEVBQXVCLEVBQUU7SUFDdkUsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDZCQUFxQixDQUFDLElBQUksQ0FBQTtBQUNqRCxDQUFDLENBQUE7QUFGWSxRQUFBLGFBQWEsaUJBRXpCIn0=